export const cardSizes = {
  sm: {
    width: 316,
    gap: 20,
  },
  lg: {
    width: 290,
    gap: 24,
  },
  xxl: {
    width: 460,
    gap: 30,
  },
};
